import { render, staticRenderFns } from "./FlexTablePro.vue?vue&type=template&id=497e305e&scoped=true"
import script from "./FlexTablePro.vue?vue&type=script&lang=js"
export * from "./FlexTablePro.vue?vue&type=script&lang=js"
import style0 from "./FlexTablePro.vue?vue&type=style&index=0&id=497e305e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497e305e",
  null
  
)

export default component.exports